import React, { useState, useEffect } from 'react';
import './VisualizarPedidos.css';
import { useOrders } from '../../contexts/OrdersContext';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar/sidebar';
import { Stack, Typography, Box, Container, Grid2} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Buttons from '../../components/button';
import DataTable from '../../components/data table/data-table';
import Button from '../../components/button';


const VisualizarPedidos = () => {
    const navigate = useNavigate();
    const {order, samples, fetchOrderById} = useOrders();
    const [currentStep, setCurrentStep] = useState(1);
    const [pedido, setPedido] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { numPedido } = useParams<{ numPedido: string }>();

    const pedidosNavigation = () => {
      navigate('/pedidos'); 
    };
    useEffect(() => {
        if (numPedido) {
            console.log(numPedido);
            fetchOrderById(numPedido);
        }
    }, [numPedido]);
    
    
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPedido(e.target.value);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
        <Header />
        {/* <Sidebar /> */}
        <Box className='import-form-content'>
            <Box className="page-link">
                <Buttons label="Voltar"
                    onClick={pedidosNavigation}
                    backgroundColor="#FBFBFB"
                    textColor="var(--primary-color)"
                    starticon={<ArrowBackIcon />}
                    sx={{
                        boxShadow: 'none', 
                        padding: '0.5rem 1rem', 
                        marginBottom: '0.5rem', 
                        '&:hover': {
                            backgroundColor: 'var(--secondary-color)', 
                            boxShadow: 'none', 
                        },
                    }} />
            </Box>
            <Container className="import-page-title">
                <Stack direction="row" spacing={2}>
                        <Box className="import-title-icon">
                            <SvgIcon>
                                <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.3691 9.50594L17.2441 3.38094C17.1627 3.29971 17.0662 3.2353 16.96 3.19138C16.8538 3.14747 16.7399 3.12491 16.625 3.125H6.125C5.66087 3.125 5.21575 3.30937 4.88756 3.63756C4.55937 3.96575 4.375 4.41087 4.375 4.875V24.125C4.375 24.5891 4.55937 25.0342 4.88756 25.3624C5.21575 25.6906 5.66087 25.875 6.125 25.875H21.875C22.3391 25.875 22.7842 25.6906 23.1124 25.3624C23.4406 25.0342 23.625 24.5891 23.625 24.125V10.125C23.6251 10.0101 23.6025 9.89623 23.5586 9.79001C23.5147 9.68379 23.4503 9.58726 23.3691 9.50594ZM17.5 6.11203L20.638 9.25H17.5V6.11203ZM21.875 24.125H6.125V4.875H15.75V10.125C15.75 10.3571 15.8422 10.5796 16.0063 10.7437C16.1704 10.9078 16.3929 11 16.625 11H21.875V24.125ZM18.375 15.375C18.375 15.6071 18.2828 15.8296 18.1187 15.9937C17.9546 16.1578 17.7321 16.25 17.5 16.25H10.5C10.2679 16.25 10.0454 16.1578 9.88128 15.9937C9.71719 15.8296 9.625 15.6071 9.625 15.375C9.625 15.1429 9.71719 14.9204 9.88128 14.7563C10.0454 14.5922 10.2679 14.5 10.5 14.5H17.5C17.7321 14.5 17.9546 14.5922 18.1187 14.7563C18.2828 14.9204 18.375 15.1429 18.375 15.375ZM18.375 18.875C18.375 19.1071 18.2828 19.3296 18.1187 19.4937C17.9546 19.6578 17.7321 19.75 17.5 19.75H10.5C10.2679 19.75 10.0454 19.6578 9.88128 19.4937C9.71719 19.3296 9.625 19.1071 9.625 18.875C9.625 18.6429 9.71719 18.4204 9.88128 18.2563C10.0454 18.0922 10.2679 18 10.5 18H17.5C17.7321 18 17.9546 18.0922 18.1187 18.2563C18.2828 18.4204 18.375 18.6429 18.375 18.875Z" fill="#2D7A89"/>
                                </svg>
                            </SvgIcon>
                        </Box>
                    <Typography className="view-title-name"> Pedido nº {numPedido} </Typography>
                </Stack>
            </Container>

            <Box className='view-form'>
                <Box sx={{margin: '20px', display: 'flex', flexDirection: 'row', gap: '100px', justifyContent: 'flex-star', justifyItems:'flex-start'}}>
                    <Box sx={{display: 'flex', justifyContent: 'flex-star', justifyItems:'flex-start', flexDirection: 'column'}}>
                        <Typography className='view-data-columns'>Nº PEDIDO</Typography>
                        <Typography className='view-data'>{numPedido}</Typography>
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'flex-star', justifyItems:'flex-start', flexDirection: 'column'}}>
                        <Typography className='view-data-columns'>CLIENTE</Typography>
                        <Typography className='view-data'>{order?.customer?.name || 'Carregando...'}</Typography>
                    </Box>
                    {/*<Box sx={{display: 'flex', justifyContent: 'flex-star', justifyItems:'flex-start', flexDirection: 'column'}}>
                        <Typography className='view-data-columns'>DATA APROVAÇÃO</Typography>
                        <Typography className='view-data'>{order?.customer.name}</Typography>
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'flex-star', justifyItems:'flex-start', flexDirection: 'column'}}>
                        <Typography className='view-data-columns'>Nº AMOSTRAS</Typography>
                        <Typography className='view-data'>12</Typography>
                    </Box>
                    <Button
                            label="Relatório do Pedido"
                            onClick={() => alert('Botão clicado!')}
                            backgroundColor="#fff"
                            borderColor="var(--primary-color)"
                            textColor="var(--primary-color)"
                            endicon={<SvgIcon><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 8.5V12.5C15 12.7652 14.8946 13.0196 14.7071 13.2071C14.5196 13.3946 14.2652 13.5 14 13.5H2C1.73478 13.5 1.48043 13.3946 1.29289 13.2071C1.10536 13.0196 1 12.7652 1 12.5V8.5C1 8.23478 1.10536 7.98043 1.29289 7.79289C1.48043 7.60536 1.73478 7.5 2 7.5H4.5C4.63261 7.5 4.75979 7.55268 4.85355 7.64645C4.94732 7.74021 5 7.86739 5 8C5 8.13261 4.94732 8.25979 4.85355 8.35355C4.75979 8.44732 4.63261 8.5 4.5 8.5H2V12.5H14V8.5H11.5C11.3674 8.5 11.2402 8.44732 11.1464 8.35355C11.0527 8.25979 11 8.13261 11 8C11 7.86739 11.0527 7.74021 11.1464 7.64645C11.2402 7.55268 11.3674 7.5 11.5 7.5H14C14.2652 7.5 14.5196 7.60536 14.7071 7.79289C14.8946 7.98043 15 8.23478 15 8.5ZM7.64625 8.35375C7.69269 8.40024 7.74783 8.43712 7.80853 8.46228C7.86923 8.48744 7.93429 8.50039 8 8.50039C8.06571 8.50039 8.13077 8.48744 8.19147 8.46228C8.25217 8.43712 8.30731 8.40024 8.35375 8.35375L11.3538 5.35375C11.4476 5.25993 11.5003 5.13268 11.5003 5C11.5003 4.86732 11.4476 4.74007 11.3538 4.64625C11.2599 4.55243 11.1327 4.49972 11 4.49972C10.8673 4.49972 10.7401 4.55243 10.6462 4.64625L8.5 6.79313V1.5C8.5 1.36739 8.44732 1.24021 8.35355 1.14645C8.25979 1.05268 8.13261 1 8 1C7.86739 1 7.74021 1.05268 7.64645 1.14645C7.55268 1.24021 7.5 1.36739 7.5 1.5V6.79313L5.35375 4.64625C5.25993 4.55243 5.13268 4.49972 5 4.49972C4.86732 4.49972 4.74007 4.55243 4.64625 4.64625C4.55243 4.74007 4.49972 4.86732 4.49972 5C4.49972 5.13268 4.55243 5.25993 4.64625 5.35375L7.64625 8.35375ZM12.5 10.5C12.5 10.3517 12.456 10.2067 12.3736 10.0833C12.2912 9.95999 12.1741 9.86386 12.037 9.80709C11.9 9.75033 11.7492 9.73547 11.6037 9.76441C11.4582 9.79335 11.3246 9.86478 11.2197 9.96967C11.1148 10.0746 11.0434 10.2082 11.0144 10.3537C10.9855 10.4992 11.0003 10.65 11.0571 10.787C11.1139 10.9241 11.21 11.0412 11.3333 11.1236C11.4567 11.206 11.6017 11.25 11.75 11.25C11.9489 11.25 12.1397 11.171 12.2803 11.0303C12.421 10.8897 12.5 10.6989 12.5 10.5Z" fill="#2D7A89"/>
                                </svg>
                                </SvgIcon>}
                            sx={{ width: '189px' }}
                    /> */}
                </Box>
                <Box sx={{ margin: '20px', display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center', 
                                alignItems: 'center'}}>
                    <DataTable data={samples} />
                </Box>
            </Box>            
        </Box>
    </>

    );
}

export default VisualizarPedidos;